<template>
  <div class="h-full flex">
    <div class="h-full w-300px flex-shrink-0" v-if="showTree">
      <el-card class="h-full">
        <div class="mb-10px flex items-center text-14px">
          <span class="border-l-3 border-color-primary flex-1 pl-10px text-18px">题库</span>
          <el-dropdown>
            <span class="el-dropdown-link">
              <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
            </span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item @click.native="operateTree(true)">展开全部</el-dropdown-item>
              <el-dropdown-item @click.native="operateTree(false)">收起全部</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        </div>
        <div class="flex mb-10px">
          <el-input
            size="small"
            placeholder="请输入题库名称"
            prefix-icon="el-icon-search"
            v-model="treeKeyword"
            class="mr-10px flex-1"
            clearable
            @keyup.enter.native="searchTreeData"
          ></el-input>
          <el-button type="primary" class="!h-36px" size="mini" @click="searchTreeData"
            >搜索</el-button
          >
          <el-button
            type="primary"
            class="!h-36px"
            size="mini"
            @click="handleTreeData('', 'createQuestion')"
            >新增</el-button
          >
        </div>
        <div class="tree overflow-y-auto">
          <el-tree
            v-if="treeStandBy"
            :default-expand-all="defaultExpandAll"
            v-loading="treeLoading"
            highlight-current
            :data="treeData"
            @node-click="handleDocNodeClick"
            :filter-node-method="filterTreeNode"
            :expand-on-click-node="false"
            :props="defaultTreeProps"
            node-key="id"
            ref="tree"
            :default-expanded-keys="defaultExpandIds"
            @node-expand="nodeExpand"
            @node-collapse="nodeCollapse"
          >
            <div slot-scope="{ node, data }" class="node-item">
              <div class="custom-tree-node">
                <p :title="node.label" class="flex-1 mr-15px truncate">
                  {{ node.label }}
                </p>
                <!-- <p :title="node.displayName" class="flex-1 mr-15px truncate">
                    {{ node.displayName }}
                  </p> -->
                <div class="mr-5px">
                  <el-dropdown>
                    <span class="el-dropdown-link">
                      <i class="iconfont icon-line-moreVertical text-14px font-bold"></i>
                    </span>
                    <el-dropdown-menu slot="dropdown">
                      <el-dropdown-item
                        @click.native="handleTreeData($event, 'createChild', data)"
                        :disabled="node.level > 1"
                        >新增</el-dropdown-item
                      >
                      <el-dropdown-item
                        @click.native="
                          handleTreeData($event, data.parentId ? 'editChild' : 'edit', data)
                        "
                        >编辑</el-dropdown-item
                      >
                      <el-dropdown-item
                        @click.native="
                          removeTreeData(
                            $event,
                            data.parentId ? 'deleteChild' : 'delete',
                            data,
                            data
                          )
                        "
                        >删除</el-dropdown-item
                      >
                    </el-dropdown-menu>
                  </el-dropdown>
                </div>
              </div>
            </div>
          </el-tree>
        </div>
      </el-card>
    </div>
    <div class="h-full rightCol flex-auto w-0px ml-10px">
      <el-card class="h-full">
        <div class="w-full h-full" v-if="currentComp === 'TABLE'">
          <div class="flex mb-20px mr-10px">
            <el-input
              size="small"
              class="mr-10px !w-50"
              placeholder="题目模糊搜索"
              maxlength="50"
              v-model="equipSearchData.keywords"
              clearable
            ></el-input>
            <el-select
              v-model="equipSearchData.examType"
              size="small"
              class="mr-10px !w-50"
              placeholder="请选择题目类型"
              clearable
              filterable
              multiple
              collapse-tags
            >
              <el-option
                v-for="item in questionList"
                :key="item.code"
                :label="item.displayName"
                :value="item.code"
              ></el-option>
            </el-select>
            <el-button size="small" type="primary" @click="handleSearch()">搜索</el-button>
            <el-button size="small" @click="resetText()">重置</el-button>
            <el-button
              size="small"
              type="primary"
              @click="handleEvent(null, 'create')"
              :disabled="!$hasAccess('create')"
              >新增</el-button
            >
            <el-button
              size="small"
              type="danger"
              @click="handleEvent(null, 'batchDelete')"
              :disabled="!$hasAccess('delete')"
              >批量删除</el-button
            >
            <el-button
              size="small"
              @click="handleEvent(null, 'batchImport')"
              :disabled="!$hasAccess('batchImport')"
              >导入</el-button
            >
            <el-button
              size="small"
              @click="handleEvent(null, 'batchExport')"
              :disabled="!$hasAccess('batchExport')"
              >导出</el-button
            >
          </div>
          <el-table
            :data="equipDataList"
            border
            class="w-full"
            :height="tableHeight"
            stripe
            v-loading="equipTableLoading"
            @selection-change="handleSelectionEquip"
          >
            <el-table-column type="selection" width="50"></el-table-column>
            <el-table-column label="序号" type="index" width="50"></el-table-column>
            <el-table-column label="编号" prop="no" width="150"></el-table-column>
            <el-table-column label="题目及答案" prop="name">
              <template slot-scope="scope">
                <question-content-view
                  :key="scope.row.id"
                  :row="scope.row"
                  :index="scope.$index"
                  :pageConfig="equipPageConfig"
                ></question-content-view>
              </template>
            </el-table-column>
            <!-- <el-table-column
              label="题目配图"
              width="100"
              prop="topicIllustrated"
              show-overflow-tooltip
            >
              <template slot-scope="scope">
                <question-view-image
                  :key="scope.row.id"
                  v-if="scope.row.topicIllustrated"
                  :imgStr="scope.row.topicIllustrated"
                ></question-view-image>
              </template>
            </el-table-column> -->
            <el-table-column label="知识点所在章节" prop="title" width="180" show-overflow-tooltip>
            </el-table-column>
            <el-table-column
              label="题目重要性"
              width="180"
              show-overflow-tooltip
              prop="importantName"
            >
            </el-table-column>
            <el-table-column label="题目类型" prop="examType" width="80" show-overflow-tooltip>
              <template slot-scope="scope">
                <span>{{ questionListMap(scope.row) }}</span>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="220" fixed="right">
              <template slot-scope="scope">
                <table-operate-button :key="scope.row.id" :buttons="buttonsEquip(scope.row)" />
              </template>
            </el-table-column>
          </el-table>
          <el-pagination
            background
            @size-change="equipTableSizeChange"
            @current-change="equipTableCurrentChange"
            :current-page.sync="equipPageConfig.SkipCount"
            :page-size.sync="equipPageConfig.MaxResultCount"
            layout="total, sizes, prev, pager, next, jumper"
            :page-sizes="[15, 30, 45, 60, 75, 90]"
            :total="equipTotalCount"
            class="float-right mt-20px ml-10px"
          ></el-pagination>
        </div>

        <topic-origin-form
          v-if="['CREATE', 'UPDATE', 'READ'].includes(currentComp)"
          :pageType="pageType"
          :treeData="treeData"
          :currentTreeSelect="currentTreeSelect"
          :rowId="rowId"
          :questionImportantList="questionImportantList"
          :questionSourceId="questionSourceId"
          @refreshList="refreshList"
          @cancel="checkComp('TABLE')"
        ></topic-origin-form>
        <wiz-upload-file
          v-dialogDrag
          elemengt-load-text="加载中..."
          :uploadFileProps="uploadFileProps"
          @exportTemplate="exportTemplate"
          @importTemplate="importTemplate"
          @exportResults="exportResults"
          @refreshList="refreshList"
        ></wiz-upload-file>
      </el-card>
    </div>
    <!-- 新增 -->
    <el-dialog
      :close-on-click-modal="false"
      :title="addQuestionFormTitle"
      :visible.sync="addQuestionFormVisible"
      width="718px"
      class="small-dialog"
      v-dialogDrag
    >
      <el-form
        :model="addQuestionForm"
        :rules="addQuestionFormRules"
        ref="aptitudeForm"
        label-width="150px"
      >
        <el-form-item label="序号" prop="index">
          <el-input
            placeholder="请输入序号"
            v-model="addQuestionForm.index"
            size="small"
            type="number"
            min="0"
            clearable
          ></el-input>
        </el-form-item>
        <el-form-item :label="formItemLabel" prop="name">
          <el-input
            placeholder="请输入"
            v-model="addQuestionForm.name"
            size="small"
            clearable
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer flex justify-center items-center">
        <el-button size="small" type="primary" icon="iconfont icon-save" @click="saveQuestionBank"
          >保存</el-button
        >
        <el-button size="small" icon="iconfont icon-close" @click="cancelAdd">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { QuestionSourceApi, QuestionBankApi, QuestionChapterApi } from '@wiz-api/exam-management'
import { wizUploadFile } from '@wiz-core/compts'
import TableOperateButton from '@/components/safety/TableOperateButton/TableOperateButton'
import utils from '@/components/safety/enumField/utils'
import DownResultFile from '@/assets/js/safety/DownResultFile'
import { typeList } from '../components/EnumField'
import TopicOriginForm from '../components/TopicOriginForm'
import QuestionContentView from '../components/QuestionContentView'

const questionSourceApi = new QuestionSourceApi()
const questionBankApi = new QuestionBankApi()
const questionChapterApi = new QuestionChapterApi()
export default {
  name: 'topic-origin-management',
  mixins: [DownResultFile],
  components: {
    TableOperateButton,
    wizUploadFile,
    TopicOriginForm,
    QuestionContentView,
  },
  data() {
    return {
      uploadLoading: false,
      questionSourceId: '',
      createType: 'createQuestion',
      showTree: true,
      addQuestionForm: {
        index: 1,
        name: '',
      },
      treeDataLength: 0,
      addQuestionFormTitle: '新增题库',
      formItemLabel: '章节名称',
      treeStandBy: true, // 是否显目录树 用于刷新树
      addQuestionFormRules: {
        name: [
          {
            required: true,
            message: '请输入',
            trigger: 'blur',
          },
        ],
      },
      currentTreeSelect: {},
      addQuestionFormVisible: false,
      treeKeyword: '',
      treeLoading: false,
      defaultTreeProps: {
        children: 'children',
        label: 'name',
      },
      defaultExpandAll: false,
      treeData: [],
      defaultExpandIds: [],
      // 行id
      rowId: undefined,
      // 题目类型
      questionList: typeList,
      pageType: 'create',
      currentComp: 'TABLE',
      uploadFileProps: {
        templateLoading: false, // 模板加载状态
        visible: false, // 是否开启弹窗
        active: 0, // 目前状态页面0为下载模板 1为上传模板 2为完成
        btnLoading: false, // 按钮加载状态
        isTestAndVerify: true, // 是否开启校验格式
        type: ['xls', 'xlsx'], // 检验文件格式，为数组可传多种同类型格式
        successCount: 0, // 上传成功条数
        failureCount: 0, // 上传失败条数
        resultFile: '', // 导入结果id，下载导入结果时需要使用
      },
      // 设备设施清单
      equipDataList: [],
      equipTableLoading: false,
      equipTotalCount: 0,
      equipSearchData: {
        examType: [],
        keywords: '',
      },
      equipPageConfig: {
        SkipCount: 1,
        MaxResultCount: 15,
      },
      selectionEquipData: [],
      questionImportantList: [],
    }
  },
  computed: {
    tableHeight() {
      return 'calc(100% - 110px)'
    },
    questionListMap() {
      return (val) => {
        return (
          _.find(this.questionList, (item) => {
            return item.code === val.examType
          })?.displayName || ''
        )
      }
    },
    buttonsEquip() {
      return (val) => {
        return [
          {
            text: '查看',
            click: () => {
              return this.handleEvent(val, 'read')
            },
            isShow: this.$hasAccess('read'),
          },
          {
            text: '编辑',
            click: () => {
              return this.handleEvent(val, 'update')
            },
            isShow: this.$hasAccess('update'),
          },
          {
            text: '删除',
            click: () => {
              return this.handleEvent(val, 'delete')
            },
            isShow: this.$hasAccess('delete'),
          },
        ]
      }
    },
  },
  created() {},
  methods: {
    cancelAdd() {
      this.addQuestionFormVisible = false
      this.addQuestionForm.name = ''
    },
    async saveQuestionBank() {
      if (this.createType === 'createQuestion') {
        if (this.addQuestionForm.index.length > 50) {
          this.$message({
            message: '序号不能超过50个字符',
            type: 'warning',
          })
          return
        }
        if (this.addQuestionForm.name.length > 500) {
          this.$message({
            message: '题库名称不能超过500个字符',
            type: 'warning',
          })
          return
        }
        const [err, res] = await questionBankApi.create({
          body: {
            name: this.addQuestionForm.name,
            sortNum: parseInt(this.addQuestionForm.index, 10),
          },
        })
        if (!err) {
          this.$message({
            message: '新增成功',
            type: 'success',
          })
          this.addQuestionFormVisible = false
          this.getQuestionBankList()
        }
      }
      if (this.createType === 'createChild') {
        if (this.addQuestionForm.index.length > 20) {
          this.$message({
            message: '序号不能超过20个字符',
            type: 'warning',
          })
          return
        }
        if (this.addQuestionForm.name.length > 200) {
          this.$message({
            message: '题库名称不能超过200个字符',
            type: 'warning',
          })
          return
        }
        const [err, res] = await questionChapterApi.create({
          body: {
            title: this.addQuestionForm.name,
            sortNum: parseInt(this.addQuestionForm.index, 10),
            questionBankId: this.currentTreeSelect.id,
          },
        })
        if (!err) {
          this.$message({
            message: '新增成功',
            type: 'success',
          })
          this.addQuestionFormVisible = false
          this.getQuestionBankList()
        }
      }
      if (this.createType === 'edit') {
        if (this.addQuestionForm.index.length > 50) {
          this.$message({
            message: '序号不能超过50个字符',
            type: 'warning',
          })
          return
        }
        if (this.addQuestionForm.name.length > 500) {
          this.$message({
            message: '题库名称不能超过500个字符',
            type: 'warning',
          })
          return
        }
        const [err, res] = await questionBankApi.update(this.currentTreeSelect.id, {
          body: {
            name: this.addQuestionForm.name,
            sortNum: parseInt(this.addQuestionForm.index, 10),
            id: this.currentTreeSelect.id,
          },
        })
        if (!err) {
          this.$message({
            message: '修改成功',
            type: 'success',
          })
          this.addQuestionFormVisible = false
          this.getQuestionBankList()
        }
      }
      if (this.createType === 'editChild') {
        if (this.addQuestionForm.index.length > 20) {
          this.$message({
            message: '序号不能超过20个字符',
            type: 'warning',
          })
          return
        }
        if (this.addQuestionForm.name.length > 200) {
          this.$message({
            message: '题库名称不能超过200个字符',
            type: 'warning',
          })
          return
        }
        const [err, res] = await questionChapterApi.update(this.currentTreeSelect.id, {
          body: {
            title: this.addQuestionForm.name,
            sortNum: parseInt(this.addQuestionForm.index, 10),
            id: this.currentTreeSelect.id,
            questionBankId: this.currentTreeSelect.parentId,
          },
        })
        if (!err) {
          this.$message({
            message: '新增成功',
            type: 'success',
          })
          this.addQuestionFormVisible = false
          this.getQuestionBankList()
        }
      }
    },
    searchTreeData() {
      this.$refs.tree.filter(this.treeKeyword)
    },
    // 获取题库
    async getQuestionBankList() {
      const data = {
        keywords: this.treeKeyword, // 每页多少条
      }
      this.treeLoading = true
      const [err, res] = await questionBankApi.getTreeList(data)
      if (!err) {
        this.treeData = res.map((item, index) => {
          item.childs = item.childs.map((child, childIndex) => {
            return {
              parentId: item.id,
              name: child.chapterName,
              id: child.chapterId,
              index: child.sortNum,
              mainId: child.id,
            }
          })
          return {
            name: item.questionBankName,
            id: item.id,
            index: item.sortNum,
            children: item.childs || [],
          }
        })
        this.treeDataLength = res.totalCount
      }
      this.treeLoading = false
    },
    operateTree(bool) {
      this.defaultExpandIds = this.$options.data().defaultExpandIds
      this.treeStandBy = false
      this.defaultExpandAll = bool
      this.$nextTick(() => {
        this.treeStandBy = true
      })
    },
    async removeTreeData(e, type, data) {
      this.$confirm(`是否确认删除${type === 'delete' ? '题库' : '章节'}`, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning',
      }).then(async () => {
        if (type === 'delete') {
          const [err, res] = await questionBankApi.callDelete(data.id)
          if (!err) {
            this.$message({
              message: '删除成功',
              type: 'success',
            })
          }
        }
        if (type === 'deleteChild') {
          const [err, res] = await questionChapterApi.remove({
            body: { id: data.mainId, questionBankId: data.parentId, questionChapterId: data.id },
          })
          if (!err) {
            this.$message({
              message: '删除成功',
              type: 'success',
            })
          }
        }
        this.getQuestionBankList()
      })
    },
    async handleTreeData(e, type, data) {
      this.currentTreeSelect = data
      this.createType = type
      this.addQuestionForm.name = ''
      this.addQuestionFormVisible = true
      if (type === 'createQuestion') {
        this.addQuestionFormTitle = '新增题库'
        this.formItemLabel = '题库名称'

        this.addQuestionForm.index = this.treeData.length + 1
      }
      if (type === 'createChild') {
        this.addQuestionFormTitle = '新增章节'
        this.formItemLabel = '章节名称'
        this.addQuestionForm.index = data.children.length + 1
      }
      if (type === 'edit') {
        this.addQuestionFormTitle = '修改题库'
      }
      if (type === 'editChild') {
        this.addQuestionFormTitle = '修改章节'
      }
      if (type === 'edit' || type === 'editChild') {
        this.addQuestionForm.name = data.name

        this.addQuestionForm.index = data.index
      }
    },
    filterTreeNode(value, data) {
      if (!value) {
        return true
      }
      return data.name.indexOf(value) !== -1
    },
    handleDocNodeClick(e, node, data) {
      this.addQuestionForm.index = node.level
      this.currentTreeSelect = node.data
      this.getEquipList()
    },
    // 节点展开
    nodeExpand(data) {
      this.currentTreeSelect = { ...data, parentId: '' }
    },
    // 节点关闭
    nodeCollapse(data) {},
    // 刷新接口
    refreshList() {
      this.equipDataList = []
      this.showTree = true
      this.checkComp('TABLE')
      this.handleSearch()
    },
    // 切换组件
    checkComp(name) {
      this.equipDataList = []
      this.currentComp = null
      this.$nextTick(() => {
        this.currentComp = name
        if (name === 'TABLE') {
          this.showTree = true
          this.$nextTick(() => {
            if (this.currentTreeSelect?.id) {
              this.defaultExpandIds = [this.currentTreeSelect.id]
              this.$refs.tree.setCurrentKey(this.currentTreeSelect.id)
            }
            this.getEquipList()
          })
        }
      })
    },
    // 重置
    resetText() {
      this.equipDataList = []
      this.currentTreeSelect = {}
      this.equipSearchData = this.$options.data().equipSearchData
      this.handleSearch()
    },
    // 上传文件
    async importTemplate(file) {
      this.uploadFileProps.btnLoading = true
      const formData = new FormData()
      _.forIn({ file }, (value, key) => {
        formData.append('input', value)
      })
      const [err, res] = await questionSourceApi.importFromExcelZip_0(
        this.currentTreeSelect.parentId || this.currentTreeSelect.id,
        {
          file: formData.get('input'),
          questionChapterId: this.currentTreeSelect.parentId ? this.currentTreeSelect.id : '',
        }
      )
      if (!err) {
        if (res.code === 1) {
          this.uploadFileProps.successCount = res.data?.numberSuccesses
          this.uploadFileProps.failureCount = res.data?.numberFailures
          // 如需兼容老样式，则resultFile字段为空或者不设置皆可
          this.uploadFileProps.resultFile = res.data?.fileId
          this.uploadFileProps.active = 2
          this.handleSearch()
        } else {
          this.$message({
            showClose: true,
            message: res.msg,
            type: 'error',
          })
        }
      }
      this.uploadFileProps.btnLoading = false
    },
    // 下载模板
    async exportTemplate() {
      if (!this.currentTreeSelect.id) {
        this.$message({
          message: '请选择题库',
          type: 'warning',
        })
        return
      }
      this.uploadFileProps.templateLoading = true
      const [err, res] = await questionSourceApi.importFromExcelTemplateFile(
        this.currentTreeSelect.parentId
          ? this.currentTreeSelect.parentId
          : this.currentTreeSelect.id,
        {
          chapterId: this.currentTreeSelect.parentId ? this.currentTreeSelect.id : '',
        }
      )
      this.uploadFileProps.templateLoading = false
      if (!err) {
        this.downLoadExcel('题源管理模板', res)
        this.$message({
          showClose: true,
          message: '模板下载成功',
          type: 'success',
        })
      }
    },
    downLoadExcel(fileName = '下载文件', data) {
      const blob = new Blob([data], {
        type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
      })
      const link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = `${fileName}`
      link.click()
      window.URL.revokeObjectURL(link.href)
    },
    // 列表操作-事件 设备设施清单
    async handleEvent(row = null, operation) {
      let err = null
      let res = null
      switch (operation) {
        case 'create':
          if (!this.currentTreeSelect.parentId) {
            this.$message({ message: '请选择章节', type: 'warning' })
            break
          }
          this.initDialog(operation)
          this.showTree = false
          break
        case 'delete':
          this.$confirm('是否删除该记录？', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await questionSourceApi.callDelete(row.id)
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        case 'read':
          this.rowId = row.id
          this.showTree = false
          this.initDialog(operation)
          break
        case 'batchImport':
          if (!this.currentTreeSelect.parentId) {
            this.$message({ message: '请选择章节', type: 'warning' })
            break
          }
          this.uploadFileProps.active = 0
          this.uploadFileProps.visible = true
          break
        case 'batchExport':
          const ids = _.map(this.selectionEquipData, (item) => {
            return item.id
          })
          if (!this.currentTreeSelect.id) {
            this.$message({
              message: '请选择题库',
              type: 'warning',
            })
            return
          }

          ;[err, res] = await questionSourceApi.hiddenDangersLedgerExportToExcelFile(
            this.currentTreeSelect.parentId || this.currentTreeSelect.id,
            {
              questionSourceIds: ids && ids.length > 0 ? ids : undefined,
              questionChapterId: this.currentTreeSelect.parentId ? this.currentTreeSelect.id : '',
              returnType: 'Blob',
            }
          )
          if (!err) {
            this.downLoadExcel('题源管理数据', res)
            this.$message({
              showClose: true,
              message: '导出成功',
              type: 'success',
            })
          }
          break
        case 'update':
          if (!this.currentTreeSelect.id) {
            this.currentTreeSelect.id = row.chapterId
            this.currentTreeSelect.parentId = row.questionBankId
          }
          this.showTree = false
          this.questionSourceId = row.questionSourceId
          this.rowId = row.id
          this.initDialog(operation)
          break
        // 批量删除
        case 'batchDelete':
          if (this.selectionEquipData.length === 0) {
            this.$message({
              showClose: true,
              message: '请勾选要删除的记录',
              type: 'warning',
            })
            return
          }
          this.$confirm('是否批量删除勾选的记录', '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning',
          })
            .then(async () => {
              ;[err, res] = await questionSourceApi.deleteMany({
                ids: _.map(this.selectionEquipData, (item) => {
                  return item.id
                }),
              })
              if (!err) {
                this.$message({
                  showClose: true,
                  message: '删除成功',
                  type: 'success',
                })
                this.getEquipList()
              }
            })
            .catch(() => {})
          break
        default:
          break
      }
    },
    // 弹窗初始化操作
    initDialog(operation) {
      this.checkComp(operation.toUpperCase())
      this.pageType = operation
    },
    handleSelectionEquip(values) {
      this.selectionEquipData = values
    },
    // 搜索
    handleSearch() {
      this.equipPageConfig.SkipCount = 1
      this.getEquipList()
    },
    // 页码改变
    equipTableSizeChange(MaxResultCount) {
      this.equipPageConfig.MaxResultCount = MaxResultCount
      this.getEquipList()
    },
    // 页数改变
    equipTableCurrentChange(SkipCount) {
      this.equipPageConfig.SkipCount = SkipCount
      this.getEquipList()
    },
    // 设备设施列表
    async getEquipList() {
      this.selectionEquipData = []
      const equipSearchData = utils.deleteFormField(this.equipSearchData)
      const data = {
        maxResultCount: this.equipPageConfig.MaxResultCount, // 每页多少条
        skipCount: (this.equipPageConfig.SkipCount - 1) * this.equipPageConfig.MaxResultCount, // 跳过多少条
        ...equipSearchData,
      }
      this.equipTableLoading = true
      const [err, res] = await questionChapterApi.getQuestionSourcePagedListQuery({
        questionBankId: this.currentTreeSelect.parentId || this.currentTreeSelect.id,
        chapterId: this.currentTreeSelect.parentId ? this.currentTreeSelect.id : '',
        ...data,
      })
      if (!err) {
        this.equipDataList = res.items.map((item) => {
          this.questionImportantList.forEach((important) => {
            if (parseInt(important.code, 10) === item.importance) {
              item.importantName = important.displayName
            }
          })
          // this.treeData.forEach((tree, bankIndex) => {
          //   if (tree.id === item.questionBankId) {
          //     tree.children.forEach((child, childIndex) => {
          //       if (child.id === item.chapterId) {
          //         item.chapterSelect = `${child.name} - 第${bankIndex + 1}章 - 第${childIndex +
          //           1}节`
          //       }
          //     })
          //   }
          // })
          return item
        })
        this.equipTotalCount = res.totalCount
      }
      this.equipTableLoading = false
    },
  },
  async mounted() {
    await utils.getDataCategory(
      ['ExamManagement.DataCategory.QuestionImportance'],
      ['questionImportantList'],
      this
    )
    await this.getQuestionBankList()
    await this.getEquipList()
  },
}
</script>

<style lang="scss" scoped>
::v-deep .el-card__body {
  height: 100%;
}
.tree {
  height: calc(100% - 74px);
  ::v-deep .el-tree-node__content {
    height: 35px;
    .node-item {
      width: calc(100% - 24px);
      .custom-tree-node {
        display: flex;
        align-items: center;
        font-size: 14px;
      }
    }
  }
}
</style>
